input.fdi.wc.text{
  width: 98%;
  max-width: 98%;
  height: 30px;
  padding: 1%;
  border: none;
  &:focus{
    outline: none;
  }
}
